import { render, staticRenderFns } from "./CovidUsaTotalsTable.vue?vue&type=template&id=7f79ea72&"
import script from "./CovidUsaTotalsTable.vue?vue&type=script&lang=js&"
export * from "./CovidUsaTotalsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports